<template>
  <div>
    <customModal ref="modal" v-if="modalData" v-show="modalData" :onModalClose="onModalClose" :onModalAccept="removeSelected" :modalData="modalData"></customModal>
    <button @click="deleteModal" class="btn btn-warning">Удалить выбранные</button>
  </div>
</template>

<script>

  import api from '@/api'
  import customModal from "../../../../components/modals/customModal";

  export default {
    components: {
      customModal
    },
    props: ['selected', 'updateRecordsBySelected'],
    data() {
      this.selectedInvoicesForDelete = [];
      return {
        modalData: null
      }
    },
    methods: {
      onModalClose() {
        this.modalData = null;
      },
      async removeSelected() {
        if (!this.selected.length) {
          toastr['warning']('Ничего не выбрано');
          return;
        }
        const {data} = await api.post('/invoices/deleteInvoices', {
          'selected': this.selected
        })
        if (data.success) {
          if (this.updateRecordsBySelected) {
            this.updateRecordsBySelected(this.selected);
          }
          toastr['success']('Удалено');
          this.onModalClose();
        } else {
          if (data.messages) {
            let text = '<p>Выход в минус:</p>';
            if (typeof data.messages == 'array') {
              data.messages.forEach((m) => text += '<p>' + m.message + ': ' + m.id + '</p>');
              data.message = text;
            }else{
              data.message = text + '<p>'+data.messages+'</p>';
            }
          }
          this.modalData.errorMessage = data.message || 'Ошибка';
          this.$refs.modal.acceptBtnLoading = false;
        }

      },
      deleteModal() {
        if (this.selected && this.selected.length) {
          let body = '';
          this.selected.forEach((s) => {
            body += '<p><strong>' + s.id + '</strong> - ' + s.delivery_date + '</p>';
          })
          this.modalData = {
            header: 'Действительно хотите удалить накладные?',
            body: body,
            acceptBtnText: 'Подтвердить'
          };
        }
      }
    }
  }

</script>
